export const locale = {
    lang: 'pl',
    data: {
        'Customers': 'Klienci',
        'New': 'Nowy',
        'Edit': 'Edycja',
        'Card number': 'Numer karty',
        'Username': 'Użytkownik',
        'Phone': 'Telefon',
        'First name': 'Imię',
        'Last name': 'Nazwisko',
        'Actions': 'Akcje',
        'Customer data': 'Dane klienta',
        'First Name is required!': 'Imię jest wymagane!',
        'Last Name is required!': 'Nazwisko jest wymagane!',
        'User name is required!': 'Nazwa użytkownika jest wymagana!',
        'E-mail is required!': 'E-mail jest wymagany!',
        'Street': 'Ulica',
        'House number': 'Nr domu',
        'Flat number': 'Nr mieszkania',
        'Post code': 'Kod pocztowy',
        'City': 'Miasto',
        'Country': 'Kraj',
        'Sex': 'Płeć',
        'Female': 'Kobieta',
        'Male': 'Mężczyzna',
        'Birth day': 'Dzień urodzenia',
        'Birth month': 'Miesiąc urodzenia',
        'Birth year': 'Rok urodzenia',
        'Name day': 'Dzień imienin',
        'Name month': 'Miesiąc imienin',
        'Customer source': 'Źródło pochodzenia',
        'Save': 'Zapisz',
        'Scheduled for today': 'Umówieni na dzisiaj',
        'Created in last time': "Ostatnio dodani",
        'Personal data': 'Dane dodatkowe',
        'Summary': 'Podsumowanie',
        'Birthday': 'Data urodzenia',
        'Created at': 'Data dodania',
        'Cards': 'Karty',
        'Add card': 'Dodaj kartę',
        'Add new card to': 'Dodaj nową kartę do',
        'Available credits': 'Dostępne kredyty',
        'HISTORY': 'HISTORIA',
        'ADD SERVICE': 'DODAJ USŁUGĘ',
        'LOCK': 'ZABLOKUJ',
        'Resources in use': 'Urządzenia w użyciu',
        'In use': 'Używa',
        'Started at': 'Rozpoczęto',
        'For all services': 'Na wszystkie usługi',
        'Service': 'Usługa',
        'Credits': 'Kredyty',
        'Expiration date': 'Data ważności',
        'Add new service to card': 'Dodaj nową usługę do karty',
        'of': 'należącej do',
        'User': 'Użytkownik',
        'ACCEPT ENTRANCE': 'AKCEPTUJ WEJŚCIE',
        'ACCEPTED': 'ZAAKCEPTOWANE',
        'Type to filter customers list...': 'Filtruj listę użytkowników...',
        'Users online': 'Użytkownicy online',
        'MINUS SERVICE': 'ODEJMIJ USŁUGĘ',
        'Minus service': 'Odejmij usługę',
        'Familiarized himself with the contraindications': 'Zapoznał się z przeciwwskazaniami',
        'Read the regulations': 'Zapoznał się z regulaminem',
        'Read the price list': 'Zapoznał się z cennikiem',
        'GDPR agrees': 'Zgody RODO',
        'Consent to marketing': 'Zgody marketingowe',
        'Delete': 'Usuń',
        'QR CODE': 'KOD QR',
        'Communication': 'Komunikacja',
        'Resources online': 'Urządzenia online',
        'Registered at': 'Data rejestracji',
        'First traditional sale': 'Pierwszy zakup w salonie',
        'First online sale': 'Pierwszy zakup online',
        'Orders': "Zamówienia",
        'CHANGE NUMBER': 'ZMIEN NUMER',
        'Cards quantity': 'Ilość kart',
        'Reservations': 'Rezerwacje',
        'Notification history': 'Historia wiadomości',
        'ACCEPT EXIT': 'AKCEPTUJ WYJŚCIE',
        'EXIT ACCEPTED': 'WYJŚCIE ZAAKCEPTOWANE',
        'ADD VOUCHER': 'DODAJ KARNET',
        'Created': 'Utworzono',
        'Description': 'Treść',
        'Add note': 'Dodaj notatkę',
        'ERROR LOGS': 'LOGI BŁĘDÓW',
        'Card number already exists!': 'Karta o podanym numerze już istnieje!',
        'Card is suspended.': 'Karta jest zawieszona.',
        'Card is suspended to': 'Karta jest zawieszona do',
        'UNSUSPEND': 'COFNIJ ZAWIESZENIE',
        'Online Carts': 'Koszyki online',
        'Voucher is inactive.': 'Karnet jest nie aktywny!',
        'Active vouchers': 'Aktywne karnety',
        'Add': 'Dodaj',
        'Time in club': 'Czas spędzony w klubie',
        'Card already assigned to other customer!': 'Karta jest przypisana do innego klienta!',
        'Bill': 'Rachunek',
        'Open bills': 'Otwarte rachunki',
        'DELETE': 'USUŃ',
        'MARK AS RETURNED': 'OZNACZ JAKO ZWRÓCONĄ',
        'Are you sure you want to mark card as returned?': 'Czy na pewno chcesz oznaczyć kartę jako zwróconą?',
        'Mark card as returned': 'Oznacz kartę jako zwróconą',
        'Yes': 'Tak',
        'ADD FIRST TIME VOUCHER': 'DODAJ KARNET NA PIERWSZY DZIEŃ',
        'Valid from hour': 'Aktywny od godziny',
        'Valid to hour': 'Aktywny do godziny',
        "Valid days of week": "Aktywne dni tygodnia",
        "Mondays": "Poniedziałki",
        "Tuesdays": "Wtorki",
        "Wednesdays": "Środy",
        "Thursdays": "Czwartki",
        "Fridays": "Piątki",
        "Saturdays": "Soboty",
        "Sundays": "Niedziele",
        "Customer description": "Opis klienta",
        "Company data": "Dane firmy",
        "Saving": "Zapisuję",
        "All": "Wszyscy",
        "Internet Shop": "Sklep internetowy",
        "Mobile App": "Aplikacja mobilna",
        "mobile_app": "Aplikacja mobilna",
        "internet_shop": "Sklep internetowy",
        "Day of birthday is required!": "Dzień urodzenia jest wymagany!",
        "Month of birthday is required!": "Miesiąc urodzenia jest wymagany!",
        "Year of birthday is required!": "Rok urodzenia jest wymagany!",
        "January": "Styczeń",
        "February": "Luty",
        "March": "Marzec",
        "April": "Kwiecień",
        "May": "Maj",
        "June": "Czerwiec",
        "July": "Lipiec",
        "August": "Sierpień",
        "September": "Wrzesień",
        "October": "Październik",
        "November": "Listopad",
        "December": "Grudzień",
        "Poland": "Polska",
        "Germany": "Niemcy",
        "France": "Francja",
        "United Kingdom": "Wielka Brytania",
        "Spain": "Hiszpania",
        "Italy": "Włochy",
        "Netherlands": "Holandia",
        "Belgium": "Belgia",
        "Austria": "Austria",
        "Switzerland": "Szwajcaria",
        "Czech Republic": "Czechy",
        "Slovakia": "Słowacja",
        "Hungary": "Węgry",
        "Romania": "Rumunia",
        "Bulgaria": "Bułgaria",
        "Greece": "Grecja",
        "Portugal": "Portugalia",
        "Sweden": "Szwecja",
        "Norway": "Norwegia",
        "Denmark": "Dania",
        "Finland": "Finlandia",
        "Ireland": "Irlandia",
        "Lithuania": "Litwa",
        "Latvia": "Łotwa",
        "Estonia": "Estonia",
        "Croatia": "Chorwacja",
        "Slovenia": "Słowenia",
        "Serbia": "Serbia",
        "Ukraine": "Ukraina",
        "Belarus": "Białoruś",
        "Russia": "Rosja",
        "Turkey": "Turcja",
        "United States": "Stany Zjednoczone",
        "Canada": "Kanada",
        "Mexico": "Meksyk",
        "Brazil": "Brazylia",
        "Argentina": "Argentyna",
        "Chile": "Chile",
        "China": "Chiny",
        "Japan": "Japonia",
        "South Korea": "Korea Południowa",
        "India": "Indie",
        "Australia": "Australia",
        "New Zealand": "Nowa Zelandia",
        "Search...": "Szukaj...",
        "Training History": "Historia treningów",
        "No training sessions found": "Nie znaleziono sesji treningowych",
        "Date": "Data",
        "Device": "Urządzenie",
        "Duration": "Czas trwania",
        "Distance": "Dystans",
        "Calories": "Kalorie",
        "Avg Power": "Średnia moc",
        "Status": "Status",
        "Active": "Aktywny",
        "Finished": "Zakończony",
        "View Details": "Zobacz szczegóły",
        "Performance Charts": "Wykresy wydajności",
        "Power Over Time": "Moc w czasie",
        "Speed Over Time": "Prędkość w czasie",
        "Heart Rate Over Time": "Tętno w czasie",
        "Distance & Calories Over Time": "Dystans i kalorie w czasie",
        "Training Session": "Sesja treningowa",
        "Customer": "Klient",
        "Type": "Typ",
        "Serial Number": "Numer seryjny",
        "Started": "Rozpoczęto",
        "Total Power": "Suma mocy",
        "Max Power": "Maksymalna moc",
        "Avg Speed": "Średnia prędkość",
        "Max Speed": "Maksymalna prędkość",
        "Avg Heart Rate": "Średnie tętno",
        "Max Heart Rate": "Maksymalne tętno",
        "Total Distance": "Całkowity dystans",
        "Total Calories": "Suma kalorii",
        "Logs Count": "Liczba logów",
        "Detailed Statistics": "Szczegółowe statystyki",
        "Training Log Data": "Dane z logów treningowych",
        "entries": "wpisów",
        "Timestamp": "Czas",
        "Power": "Moc",
        "Speed": "Prędkość",
        "Heart Rate": "Tętno",
        "No customer information": "Brak informacji o kliencie",
        "Customer source is required!": "Żródło pochodzenia klienta jest wymagane!",
        "Discount already used today. Next use available tomorrow.": "Zniżka została już użyta dzisiaj. Kolejne użycie będzie możliwe jutro."
    }
};
